import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
  IsBoolean,
} from "@/utils/type-vaildator";
import api from "./api";

interface UserPermissionDetailResponse {
  id: number;
  role_type: number;
  user_id: number;
  user_name: string;
  agent_id: number;
  master_user_id: number;
  user_management: number;
  permission_management: number;
  data_overview_management: number;
  content_management: number;
  order_management: number;
  attachment?: string;
  notes?: string;
  expire_at?: string;
  identity_type: number;
  role_status: number;
  video_subscribe: number;
  article_subscribe: number;
  blog_subscribe: number;
  moments_subscribe: number;
  graphic_subscribe: number;
  avatar?: string;
  personal_title?: string;
  created_at: number;
  updated_at: number;
  order_user: OrderUser;
}
interface OrderUser {
  id: string;
  user_id: string;
  user_name: string;
  personal_title: string;
  expire_at: string;
  role_status: number;
  clear_record_at?: string;
}

export class UserPermissionDetailData {
  // @Required("role_type cannot be empty")
  @IsNumber("role_type must be a number")
  roleType: number;

  // @Required("role_status cannot be empty")
  @IsNumber("role_status must be a number")
  roleStatus: number;

  @Required("user_management cannot be empty")
  @IsNumber("user_management must be a number")
  userManagement: number;

  @Required("permission_management cannot be empty")
  @IsNumber("permission_management must be a number")
  permissionManagement: number;

  @Required("data_overview_management cannot be empty")
  @IsNumber("data_overview_management must be a number")
  dataOverviewManagement: number;

  @Required("content_management cannot be empty")
  @IsNumber("content_management must be a number")
  contentManagement: number;

  @Required("order_management cannot be empty")
  @IsNumber("order_management must be a number")
  orderManagement: number;

  @Required("company_management cannot be empty")
  @IsNumber("company_management must be a number")
  companyManagement: number;

  // @Required("order_user cannot be empty")
  orderUser: OrderUserData;
}

export class OrderUserData {
  @Required("role_status cannot be empty")
  @IsNumber("role_status must be a number")
  roleStatus: number;

  @Required("expireAt cannot be empty")
  @IsString("expireAt must be a string")
  expireAt: string;

  @Required("alreadyExpired cannot be empty")
  @IsBoolean("alreadyExpired must be a boolean")
  alreadyExpired: boolean;

  @Required("clearRecordAt cannot be empty")
  @IsString("clearRecordAt must be a string")
  clearRecordAt?: string;
}

const transformAndValidateData = (
  response: UserPermissionDetailResponse
): UserPermissionDetailData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UserPermissionDetailData);
  } catch (error) {
    console.error("Agent v2 stats data validation failed:", error.message);
    throw error;
  }
};

/** 获取用户权限信息 */
export const userPermissionDetail = async ({ agentId, userId }: { agentId: string, userId: string }) => {
  const res = await api.post<UserPermissionDetailResponse>('/agent-v2/user-permission-detail', {
    agent_id: agentId,
    user_id: userId,
  });
  const data = transformAndValidateData(res.data);
  return data;
}